import { Icon, Button } from "@gds-react/core";
import { AddOutlined } from "@gds-react/icons";
import Lottie from "react-lottie";
import { Screen, Wrapper, SubTitle, Title } from "./NoAccountsPage.styles";
import accountAnimation from "./accountAnimation";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { routes } from "../../utils/routeHelper";
import { DeviceTabTypeEnum } from "../../types/DeviceTabTypeEnum";
import CoreSetupInstallation from "@gf-core/widgets/widgets/CoreSetupInstallation";
import { CorePermissionsEnum } from "@gf-core/widgets/types/CorePermissionsEnum";

export default function NoAccountsPage() {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Screen>
      <Wrapper>
        <Lottie
          speed={0.5}
          width={200}
          height={170}
          options={{
            loop: true,
            animationData: accountAnimation,
            rendererSettings: {
              preserveAspectRatio: "xMidYMid slice",
              clearCanvas: true,
            },
          }}
        />
        <Title>{t("noAccountsPage.title")}</Title>
        <SubTitle>{t("noAccountsPage.subtitle")}</SubTitle>
        <Button size="large" onClick={() => setShow(true)}>
          <Icon src={<AddOutlined />} />
          {t("noAccountsPage.createAccountButton")}
        </Button>
      </Wrapper>
      <CoreSetupInstallation
        isModal
        show={show}
        onClose={() => setShow(false)}
        onCompleted={async (accountId, installationId, deviceId) => {
          navigate(
            routes.device.set(
              accountId,
              installationId,
              deviceId,
              DeviceTabTypeEnum.Overview,
            ),
          );
        }}
        termsAndConditionsUrl={import.meta.env.VITE_TERMS_AND_CONDITIONS_URL}
        permissions={[
          CorePermissionsEnum.CREATE,
          CorePermissionsEnum.DELETE,
          CorePermissionsEnum.UPDATE,
        ]}
      />
    </Screen>
  );
}
